import { useCallback, useEffect, useState } from "react";
import BarCalendar from "../../../../Components/BarCalendar";
import { Modal } from "antd";
import { Grid, Stack, Typography, Button } from "@mui/material";
import { Box } from "@mui/material";
import moment from "moment";

const ClientEmployeeAvailability = (props) => {
  const [eventTimes, setEventTimes] = useState([]);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [submitTimeClicked, setSubmitTimeClicked] = useState("");

  // const getClientAvailability = useCallback(
  //   (clientUserId) => {
  //     axios
  //       .post("/schedule/get/clientAvailability", {
  //         ClientId: [clientUserId]
  //       })
  //       .then((response) => {
  //         let newAvailabilities = [];

  //         let fetchedAvailabilities = response.data.availabilities;

  //         let userAvailabilities = [];
  //         let combinedAvailabilities = {};
  //         let possibleAvailabilities = [];
  //         let newAvail;
  //         let eventIndex = 0;
  //         let possibleAvail;

  //         fetchedAvailabilities.forEach((availObj, userIndex) => {
  //           userAvailabilities = availObj.availability;
  //           let clientAvailabilities = userAvailabilities.filter(
  //             (jrClient) => jrClient.jobId === props.jr.job_id
  //           );
  //           clientAvailabilities.forEach((userAvail) => {
  //             newAvail = { ...userAvail };

  //             if (newAvail.startDate in combinedAvailabilities) {
  //               possibleAvailabilities = [
  //                 ...combinedAvailabilities[newAvail.startDate]
  //               ];

  //               for (
  //                 let availIndex = 0;
  //                 availIndex < possibleAvailabilities.length;
  //                 availIndex++
  //               ) {
  //                 possibleAvail = possibleAvailabilities[availIndex];
  //                 if (
  //                   (possibleAvail.startTime <= newAvail.startTime &&
  //                     possibleAvail.endTime >= newAvail.startTime) ||
  //                   (possibleAvail.startTime <= newAvail.endTime &&
  //                     possibleAvail.endTime >= newAvail.endTime) ||
  //                   (newAvail.startTime <= possibleAvail.startTime &&
  //                     newAvail.endTime >= possibleAvail.startTime) ||
  //                   (newAvail.startTime <= possibleAvail.endTime &&
  //                     newAvail.endTime >= possibleAvail.endTime) ||
  //                   possibleAvail.startTime - 1 == newAvail.endTime ||
  //                   possibleAvail.endTime == newAvail.startTime
  //                 ) {
  //                   newAvail.startTime = Math.min(
  //                     possibleAvail.startTime,
  //                     newAvail.startTime
  //                   );
  //                   newAvail.endTime = Math.max(
  //                     possibleAvail.endTime,
  //                     newAvail.endTime
  //                   );
  //                   possibleAvailabilities.splice(availIndex, 1);
  //                 }
  //               }
  //               combinedAvailabilities[newAvail.startDate] = [
  //                 ...possibleAvailabilities,
  //                 { ...newAvail }
  //               ];
  //             } else {
  //               combinedAvailabilities[userAvail.startDate] = [{ ...newAvail }];
  //             }
  //             newAvailabilities.push({
  //               ...userAvail,
  //               caption: props.jr.clientName,
  //               interactMode: "none",
  //               eventStyle:
  //                 userIndex + 1 > Object.keys(availableUserColors).length
  //                   ? "color2"
  //                   : "color1",
  //               event_id: eventIndex++
  //             });
  //           });
  //           setClientAvail(newAvailabilities);
  //           setCombAvail(combinedAvailabilities);
  //         });
  //       });
  //   },
  //   [props.jr.clientName, props.jr.job_id]
  // );

  // useEffect(() => {
  //   if (props.employee) {
  //     getEmployeeAvailability(props.employee.employee_user_id);
  //   }
  //   if (props.jr) {
  //     getClientAvailability(props.jr.client_id);
  //   }
  // }, [getClientAvailability, props.employee, props.jr]);

  const openScheduleModal = () => setScheduleModalOpen(!scheduleModalOpen);

  // const getEmployeeAvailability = (empUserId) => {
  //   setStMount(false);

  //   axios
  //     .post("/schedule/get/employeeAvailability", {
  //       EmpId: [empUserId]
  //     })
  //     .then((response) => {
  //       let newAvailabilities = [];
  //       let fetchedAvailabilities = response.data.availabilities;
  //       let userAvailabilities = [];

  //       let eventIndex = 0;

  //       fetchedAvailabilities.forEach((availObj, userIndex) => {
  //         userAvailabilities = availObj.availability;
  //         userAvailabilities.forEach((userAvail) => {
  //           newAvailabilities.push({
  //             ...userAvail,
  //             interactMode: "none",
  //             eventStyle:
  //               userIndex + 1 > Object.keys(availableUserColors).length
  //                 ? "color2"
  //                 : "color5",
  //             event_id: eventIndex++
  //           });
  //         });
  //       });

  //       setEmpAvail(newAvailabilities);
  //     });
  // };

  /**
   * @param {Array<string>} selectedList Format example: Mon, Mar 3 Afternoon
   */
  const createEvent = (selectedList) => {
    if (selectedList.length > 0) {
      const firstItem = selectedList[0];
      const dateSplit = firstItem.split(" ")
      const time = dateSplit[3]
      const day = parseInt(dateSplit[2])
      const month = dateSplit[1];
      if (isNaN(day)){
        throw new Error(`Date format is incorrect. Unable to set date in ClientEmployeeAvailability modal day:${day} is NaN`)
      }

      let monthNumber;
      switch (month){
        case "Jan":
          monthNumber = 0;
          break;
        case "Feb":
          monthNumber = 1
          break;
        case "Mar":
          monthNumber = 2
          break;
        case "Apr":
          monthNumber = 3
          break;
        case "May":
          monthNumber = 4
          break;
        case "Jun":
          monthNumber = 5
          break;
        case "Jul":
          monthNumber = 6
          break;
        case "Aug":
          monthNumber = 7
          break;
        case "Sep":
          monthNumber = 8
          break;
        case "Oct":
          monthNumber = 9
          break;
        case "Nov":
          monthNumber = 10
          break;
        case "Dec":
          monthNumber = 11
          break;
        default: 
          throw new Error(`incorrect date format failed to set availability month:${month}`)
      }

      const StartTime = new Date()
      if (new Date().getMonth() > monthNumber){
        StartTime.setFullYear(new Date().getFullYear() + 1)
      }
      StartTime.setMonth(monthNumber)
      StartTime.setDate(day)
      const EndTime = new Date(StartTime)
      if (time.includes("Morning")) {
        StartTime.setHours(8,0,0,0); // 8am
        EndTime.setHours(12,0,0,0); // 12pm
      } else if (time.includes("Afternoon")) {
        StartTime.setHours(12,0,0,0); // 12pm
        EndTime.setHours(17,0,0,0); // 5pm
      } else if (time.includes("Evening")) {
        StartTime.setHours(17,0,0,0); // 5pm
        EndTime.setHours(22,0,0,0); // 10pm
      } else {
        throw new Error(`Date format is incorrect. Unable to set date in ClientEmployeeAvailability modal time:${time} is not one of the avalible times`)
      }
      const StartDate = new Date(StartTime);

      // Call props.onSubmit if needed
      const dates = {
        StartDate,
        StartTime,
        EndTime
      }
      props.onSubmit(dates);
      openScheduleModal();
    }
  };

  return (
    <>
      <Button
        size="sm"
        type="button"
        variant="contained"
        color="primary"
        onClick={openScheduleModal}
        sx={{ ml: 2, float: "right" }}
      >
        Select Time
      </Button>

      <Modal
        title="Select Time for Event"
        open={scheduleModalOpen}
        onCancel={openScheduleModal}
        destroyOnClose={true}
        width={"800px"}
        footer={false}
      >
        <Grid>
          <Stack direction="row" spacing={1.5} sx={{ mb: 2 }}>
            <Box
              sx={{
                width: 15,
                height: 15,
                backgroundColor: "#61ddff",
              }}
            />{" "}
            <Typography variant="h6" color="secondary">
              Employee Availability
            </Typography>
            <Box
              sx={{
                width: 15,
                height: 15,
                backgroundColor: "#ffe561",
              }}
            />
            <Typography variant="h6" color="secondary">
              Client Availability
            </Typography>
            <Box
              sx={{
                width: 15,
                height: 15,
                backgroundColor: "#B0E1B0",
              }}
            />
            <Typography variant="h6" color="secondary">
              Selectable Availability
            </Typography>
            <Box
              sx={{
                width: 15,
                height: 15,
                backgroundColor: "#ffa500",
              }}
            />
            <Typography variant="h6" color="secondary">
              Selected Time
            </Typography>
          </Stack>
          <Typography variant="h6" color="secondary">
            You may only select one block for scheduling events.
          </Typography>
        </Grid>
        <BarCalendar
          availabilityArray={props.jr.client_availability}
          onSubmit={createEvent}
          jrData={props.jr}
          employeeAvailability={JSON.parse(props.employee.availability)}
          overlap={true}
        />
        {typeof eventTimes.startDate === "undefined" && submitTimeClicked ? (
          <Typography style={{ color: "red" }}>
            *Date and time are required to be selected.
          </Typography>
        ) : (
          <></>
        )}
      </Modal>
    </>
  );
};

export default ClientEmployeeAvailability;
